module.exports = __webpack_public_path__ + "img/professional-services-05.cc8064f1.jpg";